import * as types from '@/store/types'
import Vue from 'vue'
export default {
    changeStatusLoaded: (context, payload) => {
        context.loaded = payload
    },
    messageAll: (context, payload) => {
        context.messages = payload
        context.messagesLoaded = true
    },
    setMessage: (context, payload) => {
        const index = context.messages.findIndex(item => item.id === payload.id)
        context.messages[index] = payload
    },
    addMessage(context, payload) {
        context.messages.push(payload)
    },
    removeMessage(context, payload) {
        const index = context.messages.findIndex(item => item.id === payload.id)
        context.messages.splice(index, 1)
    },
    changeBotIdModelDefault: (context, botId) => {
        context.messageModelDef.bot_id = botId
        context.messageListModelDef.bot_id = botId
    },
    loadMessageLists: (context, payload) => {
        let unsortedMessagesListId = payload.find(messageList => messageList.deleted === 2)
        context.unsortedMessagesListId = unsortedMessagesListId.id
        context.messageLists = payload
        context.messageListsLoaded = true
    },
    setMessageList(context, payload) {
        const index = context.messageLists.findIndex(item => item.id === payload.id)
        context.messageLists[index] = payload
    },
    addMessageList(context, payload) {
        context.messageLists.push(payload)
    },
    deleteMessageList(context, payload) {
        const index = context.messageLists.findIndex(item => item.id === payload.id)
        context.messageLists.splice(index, 1)
    },
    allLoadedChangeValue(context, value) {
        context.messagesLoaded = false
        context.messageListsLoaded = false
    },
    loadMessageSortedInList(context, messageSortedInList) {
        context.messageSortedInList = Object.assign({}, messageSortedInList)
    },
    addMessageToMessageList (context, payload) {
        // context.messageSortedInList[payload.messageListId].splice(i, 1)
        context.messageSortedInList[payload.messageListId].push(payload.message)
    },
    deleteMessageInMessageList (context, payload) {
        context.messageSortedInList[payload.messageListId].splice(payload.index, 1)
    },
    updateMessageInMessageList (context, payload) {
        this.messageSortedInList[payload.messageListId][payload.index] = Object.assign({}, payload.messageModel)
    },
    addNewMessagesList (context, payload) {
        Vue.set(this.messageSortedInList, payload.id, [])
    }
}
